import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { InitialReviews } from './components/Reviews';
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ProductPresentation = lazy(() => import('./components/ProductPresentation').then(m => ({
  default: m.ProductPresentation
})));
const TomesContent = lazy(() => import('./components/TomesContent').then(m => ({
  default: m.TomesContent
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const FullReviews = lazy(() => import('./components/Reviews').then(m => ({
  default: m.FullReviews
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalClose = lazy(() => import('./components/FinalClose').then(m => ({
  default: m.FinalClose
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function App() {
  useEffect(() => {
    const loadPixel = () => {
      const PIXEL_ID = '2124467298394330';
      if (typeof window === 'undefined') return;
      if ((window as any).fbq) return;
      (function (f: any, b: Document, e: string, v: string) {
        let n: any;
        let t: HTMLScriptElement;
        let s: HTMLScriptElement | null;
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e) as HTMLScriptElement;
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
        if (s && s.parentNode) s.parentNode.insertBefore(t, s);else b.head.appendChild(t);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', PIXEL_ID);
      (window as any).fbq('track', 'PageView');
    };
    // Defer pixel until after first paint to not block LCP
    const ric = (window as any).requestIdleCallback;
    if (ric) {
      ric(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 1500);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-orange-200 selection:text-orange-900" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProof data-id="element-2" />
      <InitialReviews data-id="element-3" />
      <Suspense fallback={null} data-id="element-4">
        <PainPoints data-id="element-5" />
        <ProductPresentation data-id="element-6" />
        <TomesContent data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Pricing data-id="element-9" />
        <FullReviews data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalClose data-id="element-13" />
        <PurchasePopup data-id="element-14" />
      </Suspense>
    </div>;
}